package top.wcpe.allincore.ui.runtime.event

import kotlin.jvm.JvmName

/**
 * 拖拽悬停事件：拖拽过程中鼠标移动到某 dropTarget 之上时触发。
 *
 * @property sourceId 发起拖拽的元素 id
 * @property payload 拖拽携带的数据（可为 null）
 * @property mouseX 当前鼠标 X（屏幕坐标）
 * @property mouseY 当前鼠标 Y
 */
data class DragOverEvent(
    // 保留 Java 记录式访问器 ABI：消费方以 `event.sourceId()` 方法式调用
    @get:JvmName("sourceId") val sourceId: String,
    @get:JvmName("payload") val payload: Any?,
    @get:JvmName("mouseX") val mouseX: Double,
    @get:JvmName("mouseY") val mouseY: Double,
)
